// ForgotPassword.js

import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Alert } from "react-bootstrap";
import { BASE_URL } from "../utils/config";
import 'bootstrap/dist/css/bootstrap.min.css';
import background from "../images/background2.jpg";
import LOGOJI from "../images/RKLOGO.png";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@mui/material";

const ForgotPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  console.log('Location:', location); 
  const UserDetails = location.state && location.state.EditscreenUserDetails;
  // Inspect the value of 'show'
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [showmessage, setShowMessage] = useState(false);
  const [show, setShow] = useState('')
  const [role, setrole] = useState('')
  const [changepasswordData, setChangePasswordData] = useState({
    oldpassword: '',
    newpassword: '',
    confirmpassword: '',
  });
  const passwordRegex =
    /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+[\]{};:<>?]{8,}$/;
  const [showInvalidOLDPasswordAlert, setShowInvalidOLDPasswordAlert] = useState(false);
  const [showInvalidNewPasswordAlert, setShowInvalidNewPasswordAlert] = useState(false);
  const [showInvalidConfirmPasswordAlert, setShowInvalidConfirmPasswordAlert] = useState(false);
  const [showInvalidMatchPasswordAlert, setShowInvalidMatchPasswordAlert] =
    useState(false);
  const [errorDialog,setErrorDialog]=useState(false);
  const [errorMessage,setErrorMessage]=useState("");

  useEffect(() => {
    let show = location.state && location.state.show;
    setShow(show);
  })

  useEffect(() => {
    const roleType = JSON.parse(localStorage.getItem('roleType'));
    console.log("roleType:", roleType)
    setrole(roleType);
    // setUserDetails()
  }, [])


//  to handle email change
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  // to handle submit from 
  const handleSubmit = (e) => {
    try{
    e.preventDefault();


    fetch(`${BASE_URL}/forgetpassword/${email}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("res", res);


        if (res.success === true) {
          setMessage('Password reset instructions sent to your email.');
          setShowMessage(true);
        } else {
          setErrorMessage(`Error: ${res.message}`);
          setErrorDialog(true)
          setTimeout(() => {
            setErrorDialog(false)
            setErrorMessage("")
            }, 1700);
        }
      }).catch((error)=>{
        setErrorMessage(`Error: ${error.message}`);
      setErrorDialog(true)
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
      })
    }catch(error){
      setErrorMessage(`Error: ${error.message}`);
      setErrorDialog(true)
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
    }

  };

  // to handle change password 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setChangePasswordData({
      ...changepasswordData,
      [name]: value,
    });
  };

//  to handle submit new password.
  const handleChangepasswordSubmit = (e) => {
    try{
    e.preventDefault();
    console.log("inside change password")

    if (role === 'SuperAdmin') {

      if (!passwordRegex.test(changepasswordData.newpassword)) {
        setShowInvalidNewPasswordAlert(true);
        setTimeout(() => {
          setShowInvalidNewPasswordAlert(false);
        }, 5000);
      }
      else if (!passwordRegex.test(changepasswordData.confirmpassword)) {
        setShowInvalidConfirmPasswordAlert(true);
        setTimeout(() => {
          setShowInvalidConfirmPasswordAlert(false);
        }, 5000);
      }
      else if (changepasswordData.newpassword != changepasswordData.confirmpassword) {
        console.log("password and confirm password doesn't match");
        setShowInvalidMatchPasswordAlert(true);
        setTimeout(() => {
          setShowInvalidMatchPasswordAlert(false);
        }, 5000);
      } else {

        // const userdetails = JSON.parse(localStorage.getItem('userdetails'));
        const userdetails = UserDetails;
        console.log("userdetails", typeof userdetails, userdetails)
        const data = {
          oldpassword: changepasswordData.oldpassword,
          newpassword: changepasswordData.newpassword,
          roleType: role,
        }

        console.log("data", data);
        let body = JSON.stringify({ changepasswordDetails: data });
        fetch(`${BASE_URL}/changeuserpassword/${userdetails.user_id}`, {
          method: "POST",
          body,
          headers: {
            "Content-Type": "application/json",
          },
        }).then((res) => res.json())
          .then((res) => {
            console.log("res", res);
            if (res.success == true) {
              if(role === 'SuperAdmin' && UserDetails.role_type === 'SuperAdmin'){
                navigate('/login');
              }else{
                navigate('/userlist');
              }
              
            }
            else {
              alert(`${res.message}`);
            }
          })
      }

    } else {
      if (!passwordRegex.test(changepasswordData.oldpassword)) {
        setShowInvalidOLDPasswordAlert(true);
        setTimeout(() => {
          setShowInvalidOLDPasswordAlert(false);
        }, 5000);
      }
      else if (!passwordRegex.test(changepasswordData.newpassword)) {
        setShowInvalidNewPasswordAlert(true);
        setTimeout(() => {
          setShowInvalidNewPasswordAlert(false);
        }, 5000);
      }
      else if (!passwordRegex.test(changepasswordData.confirmpassword)) {
        setShowInvalidConfirmPasswordAlert(true);
        setTimeout(() => {
          setShowInvalidConfirmPasswordAlert(false);
        }, 5000);
      }
      else if (changepasswordData.newpassword != changepasswordData.confirmpassword) {
        console.log("password and confirm password doesn't match");
        setShowInvalidMatchPasswordAlert(true);
        setTimeout(() => {
          setShowInvalidMatchPasswordAlert(false);
        }, 5000);
      } else {

        // const userdetails = JSON.parse(localStorage.getItem('userdetails'));
        const userdetails = UserDetails;
        console.log("userdetails", typeof userdetails, userdetails)
        const data = {
          oldpassword: changepasswordData.oldpassword,
          newpassword: changepasswordData.newpassword,
          roleType: role,
        }

        console.log("data", data);
        let body = JSON.stringify({ changepasswordDetails: data });
        fetch(`${BASE_URL}/changeuserpassword/${userdetails.user_id}`, {
          method: "POST",
          body,
          headers: {
            "Content-Type": "application/json",
          },
        }).then((res) => res.json())
          .then((res) => {
            console.log("res", res);
            if (res.success === true) {
              navigate('/login');
            }
            else {
              setErrorMessage(`Error: ${res.message}`);
      setErrorDialog(true)
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
            }
          }).catch((error)=>{
            setErrorMessage(`Error: ${error.message}`);
      setErrorDialog(true)
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
          })
      }
    }

  }catch(error){
    setErrorMessage(`Error: ${error.message}`);
      setErrorDialog(true)
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
  }



  }



  return (
    <div className="newlogin">
      <img src={background} alt="" style={{ width: "550px", marginLeft: "15%" }} />
      <div className="box" style={{ marginLeft: "11%" }}>
        <span className="borderLine"></span>
        {show === 'forgotpassword' ?
          <div className='forgot-password-form'>
            <form onSubmit={handleSubmit}>
              <a href="https://www.iamrakeshbansal.com/" style={{ position: "absolute", top: "-2px", left: "20px", marginLeft: "32%", width: '100px' }}>
                <img src={LOGOJI} alt="RNR Logo" className="LOGO" />
              </a>

              <h4>Forgot Password</h4>
              <div className='form-group'>
                <label htmlFor='email'>Email Id  <span className='astrik-mark'>*</span> </label>
                <input
                  type='email'
                  id='email'
                  name='email'
                  value={email}
                  onChange={handleEmailChange}
                  className='form-control'
                  required
                />
              </div>
              <button type='submit' className='btn btn-primary'>
                Reset Password
              </button>
              {showmessage ?
                <p style={{ color: 'black' }}>Password reset instructions sent to your email.</p>
                : null}

              <div style={{
                marginLeft: '105px',
                marginTop: '190px'
              }}>
                <Link
                  to="/login"
                  state={{ show: "forgotpassword" }}
                  style={{ textDecoration: "underline", color: "blue" }}
                >
                  Back to Login
                </Link>
              </div>
            </form>

          </div>
          :
          <div className='forgot-password-form'>

            <form onSubmit={handleChangepasswordSubmit}>
              <a href="https://www.iamrakeshbansal.com/" style={{ position: "absolute", top: "-2px", left: "20px", marginLeft: "32%", width: '100px' }}>
                <img src={LOGOJI} alt="RNR Logo" className="LOGO" />
              </a>
              <h4 style={{ margin: '10px 0 10px 0' }}>Change Password</h4>
              <div className='form-group'>

                {role === 'SuperAdmin' ? null : <div className='form-group col'>
                  <label htmlFor='Old Password'>
                    OLD Password
                    <span className='astrik-mark'>*</span>
                  </label>
                  {showInvalidOLDPasswordAlert && (
                    <Alert
                      variant="danger"
                      onClose={() => setShowInvalidOLDPasswordAlert(false)}
                      dismissible
                    >
                      Please enter a valid password. Passwords must be at least
                      8 characters long and contain at least one letter, one
                      digit, and may include special characters.
                    </Alert>
                  )}
                  <input className='form-control form-control-lg' type='password' name='oldpassword' id='oldpassword' onChange={handleChange} required />
                </div>}

                <div className='form-group col'>
                  <label htmlFor='New Password' >
                    New Password
                    <span className='astrik-mark'>*</span>
                  </label>
                  {showInvalidNewPasswordAlert && (
                    <Alert
                      variant="danger"
                      onClose={() => setShowInvalidNewPasswordAlert(false)}
                      dismissible
                    >
                      Please enter a valid password. Passwords must be at least
                      8 characters long and contain at least one letter, one
                      digit, and may include special characters.
                    </Alert>
                  )}
                  {showInvalidMatchPasswordAlert && (
                    <Alert
                      variant="danger"
                      onClose={() => setShowInvalidMatchPasswordAlert(false)}
                      dismissible
                    >
                      Password and confirm password do not match. Please make
                      sure they are the same.
                    </Alert>
                  )}
                  <input className='form-control form-control-lg' type='password' name='newpassword' id='newpassword' onChange={handleChange} required />
                </div>
                <div className='form-group col'>
                  <label htmlFor='Confirm Password' style={{ width: '100%', display: 'block' }}>
                    Confirm New Password
                    <span className='astrik-mark'>*</span>
                  </label>
                  {showInvalidConfirmPasswordAlert && (
                    <Alert
                      variant="danger"
                      onClose={() => setShowInvalidConfirmPasswordAlert(false)}
                      dismissible
                    >
                      Please enter a valid password. Passwords must be at least
                      8 characters long and contain at least one letter, one
                      digit, and may include special characters.
                    </Alert>
                  )}
                  <input className='form-control form-control-lg' type='password' name='confirmpassword' id='confirmpassword' onChange={handleChange} required />
                </div>
              </div>

              <button type='submit' className='btn btn-primary'>
                Change Password
              </button>
            </form>
          </div>
        }
      </div>

       {/*Error Message Dialog */}
       <Dialog
        open={errorDialog}
        onClose={()=>{setErrorDialog(false)}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle  id="alert-dialog-title">
        <h4 style={{ color: "red" }}>Failure</h4>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
           
                 
            {errorMessage}
             
          
          </DialogContentText>
        </DialogContent>
       
            </Dialog>
    </div>
  );
};

export default ForgotPassword;
